<template>
  <div style="height: 70%;">
    <div class="tree-area" style="height: 73%;">
      <div class="treeselect" v-if="treeData.length > 0">
        <treeselect
          v-model="value"
          :max-height="250"
          :options="treeData"
          :default-expand-level="1"
          :always-open="alwaysOpen"
          :open-on-click="openOnClick"
          :load-options="handleOpenNode"
          :noOptionsText="$i18nUtil.trans('search.041')"
          :loadingText="$i18nUtil.trans('search.042')"
          :noChildrenText="$i18nUtil.trans('search.043')"
          @select="handleSelectNode"
        />
      </div>
      <div class="treeselect nodata" v-else>{{$i18nUtil.trans("message.InOrg.001","데이터가 없습니다.")}}</div>
    </div>
    <div class="organization-table-num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:userCount})"></div>
    <div class="organization-table-area" style="height: 73%; margin-top: 8px; overflow-y: auto;">
      <table class="organization-table tb-contents no-data">
        <colgroup>
          <col width="42px" />
        </colgroup>
        <thead>
          <tr>
            <th style="width: 51px;text-align: center;">
              <input type="checkbox" id="orgAll" v-model="orgAll" @click="handlerSelectUser($event, '', 'ALL')"/>
              <label :for="'orgAll'"></label>
            </th>
            <th style="width: 80px;">{{$i18nUtil.trans("entity.user.name","이름")}}</th>
            <th style="width: 105px; padding-left: 5px;">{{$i18nUtil.trans("entity.user.userId","아이디")}}</th>
            <th style="width: 110px; padding-left: 2px;">{{$i18nUtil.trans("entity.user.jobPositionName","직위")}}</th>
            <th style="width: 110px; padding-left: 2px;">{{$i18nUtil.trans("entity.user.jobFunctionName","직책")}}</th>
            <th style="width: 93px; padding-left: 3px;">{{$i18nUtil.trans("message.TodoDeptUserRegist.001","타입")}}</th>
          </tr>
        </thead>
        <tbody v-if="userList.length > 0">
          <tr v-for="(userList, index) in userList" :key="'org_' + index">
            <td style="width: 51px;text-align: center;">
              <input
                type="checkbox"
                :value="userList"
                :id="'orgTodoPaper_' + userList.USER_ID"
                v-model="checkUsers"
                @change="handlerSelectUser($event, userList, '')"/>
              <label :for="'orgTodoPaper_' + userList.USER_ID"></label>
            </td>
            <td style="width: 80px; padding-bottom: 15px; word-break: break-all;" class="cursor-pointer" @click="clickSelectUser(userList.USER_NAME, userList.USER_ID, userList.USER_TYPE)">
              {{ userList.USER_NAME }}</td>
            <td style="width: 105px; padding-left: 5px; word-break: break-all;" class="cursor-pointer" @click="clickSelectUser(userList.USER_NAME, userList.USER_ID, userList.USER_TYPE)">
              {{ userList.USER_ID }}</td>
            <td style="width: 110px; padding-left: 2px; word-break: break-all;">
              {{ userList.JOB_POSITION_NAME }}</td>
            <td style="width: 110px; padding-left: 2px; word-break: break-all;">
              {{ userList.JOB_FUNCTION_NAME }}</td>
              <!-- {{ userList.JOB_FUNCTION_NAME == '_' ? ' ' : userList.JOB_FUNCTION_NAME }}</td> -->
            <td style="width: 93px; padding-left: 3px;">
              {{ userList.USER_TYPE }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3" style="text-align: center;">{{$i18nUtil.trans("message.TodoDeptUserList.001","사용자 정보가 없습니다.")}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect';
import EventBus from "@/js/eventbus/eventBus";
export default {
  data() {
    return {
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      observer : null,
      /* Tree options */
      value: [],
      alwaysOpen: true,
      multipleYn: true,
      openOnClick: true,
      parentNodeId: null,

      /*  */
      orgAll : false,
      checkUsers: [],

      /* Rest */
      url: null,
      method: null,
      companyId: null,
      searchCondition: null,
      searchKeyword: null,
      treeData: [],
      userList: {},
      userCount: 0,
      rootNode : '',
      treeList : '',
    };
  },
  beforeDestroy () {
    if(this.observer !== null) {
      this.observer.disconnect();
    }
  },
  created() {
    this.getTreeData();
    /* 사용자 타입 변경하여 저장 시 */
    EventBus.$off("afterSave");
    EventBus.$on("afterSave", param => {
      let obj = this;
      obj.userList = param.userList;
      obj.userCount = param.userCount;
    });
  },
  methods: {
    /* rest Call&CallBack Action */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast"]),
    /* 권한 확인
    checkRoleTypeUser() {
      let obj = this;
      let reqData = {};
      reqData.params = {
          roleType: "TNT",
      };
      reqData.url = "/api/org/checkRoleTypeUser";
      reqData.method = "post";            
      
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.result) {
          obj.getTreeData();
        }else {
          obj.toastInfo.message = obj.$i18nUtil.trans("TB044");
          obj.showToast(obj.toastInfo);
        }
      })
      .catch(function(err) {
          console.log(err);
      });
    }, */
    /* 최초 트리 데이터 조회 */
    getTreeData() {
      let area = document.getElementsByClassName("vue-treeselect__control");
      for (let i = 0; i < area.length; i++) {
        area[i].style.display = "none";
      }
      this.resetTreeList(null);
      this.searchKeyword = null;

      let obj = this;
      
      let reqData = {
        url : "/api/org/getDeptList",
        method : "post",
        params : {
          parentDeptId : null,
          companyId : null
        }
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if(res.errorCode !== null) {
            console.log(res.errorCode);
          } else {
            /* treeData set */
            obj.rootNode = res.result.rootNode;
            obj.treeList = res.result.treeList;
            obj.setTreeList();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setTreeList(){
      this.setOrgTree(this.rootNode,this.treeList,null);
    },
    /* 노드 오픈 */
    async handleOpenNode({ action, parentNode, callback }) {
      let node = event.target;
      this.observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          node.parentNode.classList.toggle('show');
          node.parentNode.parentNode.parentNode.classList.toggle('show');
        });
      });
      let config = {
        attributes: true, childList: true, characterData: true
      }
      this.observer.observe(node, config);
      let nodeList = [];
      if(action === LOAD_CHILDREN_OPTIONS ) {
          let obj = this;
          let reqData = {
            url : "/api/org/getDeptList",
            method : "post",
            params : {
              parentDeptId : parentNode.id,
            }
          };
       await obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if(res.errorCode !== null) {
              let errorCode = res.errorCode;
            } else {
              let treeList = res.result.treeList;
             
              treeList.forEach(function(item, index, arr) {
                let node = item;
                let childYn = node.childYn;
                let nodeInfo = {
                  id: node.deptId,
                  label: node.deptName
                };
                  if (childYn > 0) {
                    nodeInfo.children = null;
                  }
                nodeList.push(nodeInfo);
              });
            }
          })
          .catch(function (err) {
            console.log(err);
          });
        parentNode.children = nodeList;
      }
    },
    /* 노드(부서) 선택 시 */
    handleSelectNode(node, instanceId) {
      this.selectNode(node, instanceId);
    },
    handlerSelectUser(event, user, type) {
      let status = event.srcElement.checked;
      if(type === "ALL") {
        if(status === true) {
          this.$emit("selectUser", {type : type, data : this.userList, target: event.target.id});
          this.checkUsers = this.userList;
        } else {
          this.$emit("deSelectUser", {type : type, data : this.userList});
          this.checkUsers = [];
        }
      } else {
        if (status === true) {
          this.$emit("selectUser", {type : type, data : user});
        } else {
          this.$emit("deSelectUser", {type : type, data : user});
          if(user.length === this.userList.length) {
            this.orgAll = true;
          } else {
            this.orgAll = false;
          }
        }
      }
    },
    /* 좌측의 사용자 목록에서 사용자 클릭 시 */
    clickSelectUser(name, id, type){
      this.$emit("clickSelectUser", {name : name, id : id, type : type});
    },
    selectNode(node, instanceId) {
      let obj = this;
      let reqData = {
        url : "/api/copaper/todo/getTodoDeptUserList",
        method : "post",
        params : {
          deptId : node.id
        }
      };
      this.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if(res.errorCode !== null) {
            console.log(res.errorCode);
          } else {
            EventBus.$emit("setDept", {
              deptName: node.label,
              deptId: node.id,
              node : node,
            });
            obj.setTreeOfUserList(res.result);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    setOrgTree(node,tree,parentNode) {
      let rootNode = node;
      let treeList = tree;
      let rootNodeInfo = null;
      let nodeListData = [];
      let searchCondition = null;

      if (rootNode !== null && rootNode !== undefined) {
        rootNodeInfo = {
          id: rootNode.deptId,
          label: rootNode.deptName,
          level: rootNode.level
        };
      }
      if (treeList !== null && treeList !== undefined) {
        treeList.forEach(function(item, index, arr) {
          let node = item;
          let childYn = node.childYn || node.level;
          let nodeInfo = {
            id: node.deptId,
            label: node.deptName,
            level: node.level
          };
          if (searchCondition === null || searchCondition === undefined) {
            if (childYn > 0) {
              nodeInfo.children = null;
            }
          }
          nodeListData.push(nodeInfo);
        });
      }
      if (rootNode !== null && rootNode !== undefined) {
        rootNodeInfo.children = nodeListData;
      }
      if (parentNode !== null) {
        parentNode.children = nodeListData;
      } else {
        this.resetTreeList(rootNodeInfo,nodeListData);
      }
    },
    resetTreeList(rootNodeInfo, nodeListData) {
      let obj = this;
      if (rootNodeInfo !== null && nodeListData !== null) {
        if (rootNodeInfo !== null) {
          obj.treeData.push(rootNodeInfo);
        } else {
          obj.treeData = nodeListData;
        }
      } else {
        obj.treeData = [];
      }
    },
    setTreeOfUserList(result) {
      let obj = this;
      if (result !== null) {
        obj.userList = result;
        obj.userCount = result.length;
      } else {
        obj.userList = {};
        obj.userCount = 0;
      }
    },
  },
};
</script>
<style scoped>
.organization-table th {
  text-align: left;
}
/* .organization-table {
  border-collapse: collapse;
  text-align: left;
}
 .organization-table td {
  text-align: left;
} */
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/TodoDeptUserList.vue